import Fragment from "./fragment";
import FragmentDataType from "../enums/fragment-data-type";
import FragmentSummary from "./fragment-summary";
import { playerReducer } from "../../../storage/reducers";
import { FragmentMessages } from "../../common/fragment-messages";

export default class KneelDown extends Fragment {
    constructor(kneelBy, kneeledAt) {
        super();
        this.kneelBy = kneelBy;
        this.kneeledAt = kneeledAt;

        this.requiredData = [
            {
                name: "kneelBy",
                type: FragmentDataType.Player,
                appliesToOpponent: () => false,
                displayName: "Kneel By",
                title: (team) => `Kneel By: ${team.teamName}`,
                subtitle: (team) =>
                    `Select a player
                     from ${team.teamName} or enter the roster number`,
                isEditable: true
            },
            {
                name: "kneeledAt",
                type: FragmentDataType.FieldPosition,
                displayName: "Kneeled At",
                title: "Kneeled At",
                subtitle: FragmentMessages.FB_TEAM_FIELD_POSITION
            }
        ];
    }

    updateSummaryContext(summaryContext) {
        summaryContext.eopPrinted = true;
    }

    getFragmentTeamId() {
        return this.kneelBy?.teamId;
    }

    getPlayers() {
        return [this.kneelBy];
    }

    getFieldPosition() {
        return this.kneeledAt;
    }

    summarize(summaryContext, stringifier) {
        const { gameConfig } = summaryContext;

        const formattedSpot = stringifier.niceFieldPosition(
            gameConfig.general.fieldLength,
            this.kneeledAt,
            summaryContext.homeTeam?.abbrName,
            summaryContext.awayTeam?.abbrName
        );

        const message = `Kneel Down by ${stringifier.firstInitial(this.kneelBy)}
		at ${formattedSpot}`;

        return new FragmentSummary(message);
    }

    toJSON() {
        return {
            ...super.toJSON(),
            kneelBy: playerReducer(this.kneelBy)
        };
    }
}
